import { render } from "./EArticle.vue?vue&type=template&id=484e4410"
import script from "./EArticle.vue?vue&type=script&lang=js"
export * from "./EArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__